import { useCallback, useState } from 'react';

function read(key: string, fallback: boolean): boolean {
  try {
    const v = localStorage.getItem(key);
    return v === null ? fallback : v === '1';
  } catch {
    return fallback;
  }
}

/**
 * A per-viewer on/off preference kept in localStorage ('1' / '0'). Storage may be
 * missing or throw (private mode, blocked site data): the flag then just lives in memory.
 */
export function useStoredFlag(key: string, fallback = false): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(() => read(key, fallback));
  const set = useCallback(
    (next: boolean) => {
      setOn(next);
      try {
        localStorage.setItem(key, next ? '1' : '0');
      } catch {
        // not persisted; the in-memory state still works
      }
    },
    [key],
  );
  return [on, set];
}
